/**
 * Custom-bounds sub-row of a compare condition: from → to, with the
 * "to = today" rolling-end checkbox. Split from CompareConditionRow so the
 * row stays under the file cap.
 * For Media Devoted | Created By Ciro Autiero
 */

import { FC } from 'react';
import type { TagCompareTo } from '@trafficpulse/shared';

export interface CompareCustomBoundsProps {
  ct: TagCompareTo;
  onPatch: (next: TagCompareTo) => void;
}

const CompareCustomBounds: FC<CompareCustomBoundsProps> = ({ ct, onPatch }) => (
  <div className="mt-2 flex flex-wrap items-center gap-2 text-xs">
    <input
      type="date"
      value={ct.fromDate ?? ''}
      onChange={(e) => onPatch({ ...ct, fromDate: e.target.value })}
      aria-label="Compare window from"
      className="h-8 rounded-md border border-input bg-background px-2"
    />
    <span className="text-muted-foreground">→</span>
    <input
      type="date"
      value={ct.toDate ?? ''}
      disabled={ct.toDateIsToday === true}
      onChange={(e) => onPatch({ ...ct, toDate: e.target.value })}
      aria-label="Compare window to"
      className="h-8 rounded-md border border-input bg-background px-2 disabled:opacity-50"
    />
    <label className="flex cursor-pointer items-center gap-1.5 text-muted-foreground">
      <input
        type="checkbox"
        checked={ct.toDateIsToday === true}
        onChange={(e) => onPatch({ ...ct, toDateIsToday: e.target.checked })}
      />
      to = today
    </label>
  </div>
);

export default CompareCustomBounds;
